import { Component, OnDestroy, OnInit } from '@angular/core';
import { GetRacunQuery, IRacunInfoDto, SubscriptionPackage, RacuniClient, StatusUplateRacuna, TipRacuna, StatusRacuna } from '@kodit/core/data-api';

import { Subscription } from 'rxjs';
import { RacunInfoService } from '../racun-info/racun-info.service';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { DodatneUplateRacunaFormComponent } from '../dodatne-uplate-racuna-form/dodatne-uplate-racuna-form.component';
import { AuthService } from '@kodit/core/services';
import { DokumentOPromeniFormComponent } from '../dokument-o-promeni-form/dokument-o-promeni-form.component';

@Component({
  selector: 'kodit-uplate-po-racunu',
  templateUrl: './uplate-po-racunu.component.html',
  styleUrls: ['./uplate-po-racunu.component.scss'],
})
export class UplatePoRacunuComponent implements OnInit, OnDestroy {
  /** Props */
  private _subs: Subscription = new Subscription();
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  racunInfoDto: IRacunInfoDto;
  statusPlacen: StatusUplateRacuna = StatusUplateRacuna.PLACEN;
  imaFinansije: boolean = false;
  showButton: boolean = false;
  showPovecanjeSmanjenjeButton: boolean = false;

  constructor(
    private _racunInfoService: RacunInfoService,
    private _dialogService: DynamicDialogService,
    private _client: RacuniClient,
    private _service: AuthService
  ) { }

  ngOnInit(): void {
    this._subs = this._racunInfoService.getRacunInfoDto.subscribe((res) => {
      this.racunInfoDto = res;
    });
    this.imaFinansije = this._service.hasPackage(SubscriptionPackage[SubscriptionPackage.FINANSIJE]);
    this._subs.add(
      this._racunInfoService.getRacunInfoDto.subscribe((res) => {
        if (res.statusUplateDto.status != StatusUplateRacuna.DELIMICNO_PLACEN) {
          this.showButton = false;
        } else {
          this.showButton = true;
        }
        this.showPovecanjeSmanjenjeButton = this.imaFinansije && res.statusDto?.status === StatusRacuna.NACRT;
      })
    );
    this.showButton = this.imaFinansije && this.racunInfoDto.statusUplateDto.status == StatusUplateRacuna.DELIMICNO_PLACEN;
    this.showPovecanjeSmanjenjeButton = this.imaFinansije && this.racunInfoDto.statusDto?.status === StatusRacuna.NACRT;
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  // evidentiranje uplate
  onEdit() {
    this.dialogConfig.data = { model: this.racunInfoDto };
    this.dialogConfig.header = 'Nova uplata računa';
    this.openDialog(DodatneUplateRacunaFormComponent, this.dialogConfig);
  }

  // evidentiranje dos
  onEvidentirajSmanjenje() {
    this.dialogConfig.data = {
      tipDokumenta: TipRacuna.DOKUMENT_O_SMANJENJU,
      vrstaRacuna: this.racunInfoDto.vrsta,
      racunId: this.racunInfoDto.id
    };
    this.dialogConfig.header = 'Evidentiranje dokumenta o smanjenju';
    this.openDialog(DokumentOPromeniFormComponent, this.dialogConfig);
  }

  // evidentirajne dop
  onEvidentirajPovecanje() {
    this.dialogConfig.data = {
      tipDokumenta: TipRacuna.DOKUMENT_O_POVECANJU,
      vrstaRacuna: this.racunInfoDto.vrsta,
      racunId: this.racunInfoDto.id
    };
    this.dialogConfig.header = 'Evidentiranje dokumenta o povećanju';
    this.openDialog(DokumentOPromeniFormComponent, this.dialogConfig);
  }

  openDialog(component: any, config: DynamicDialogConfig): void {
    const ref = this._dialogService.open(component, config);

    this._subs.add(
      ref.onClose.subscribe(() => {
        this._subs.add(
          this._client
            .getRacunInfo(new GetRacunQuery({ id: this.racunInfoDto.id }))
            .subscribe((res) => {
              this.racunInfoDto = res.data;
              this._racunInfoService.setRacunInfoDto = res.data;
            })
        )
      })
    );
  }
}